module.exports = __webpack_public_path__ + "img/cartpanda.c341f28a.png";